import { ResultDescription } from '@reduxjs/toolkit/dist/query/endpointDefinitions'
import { FetchBaseQueryError } from '@reduxjs/toolkit/query'

export const invalidateTagsIfSuccess =
  <T extends string, K extends T>(tags: K[]): ResultDescription<T, any, any, any, any> | undefined =>
  (_, errors) =>
    !errors ? tags : []

const serverErrorCodes = [500, 501, 502, 503, 504, 505, 506, 507, 508, 509, 510, 511]

function redirectOnServerError() {
  window.location.assign(`/500?from=${window.location.pathname}`)
}
function defaultRedirectOnApiError(status: '403' | '404') {
  window.location.assign(`/${status}`)
}

const REDIRECT_BY_ERROR: {
  [key in FetchBaseQueryError['status']]?: {
    redirectFunc: () => void
    excludedUrls?: string[]
    includeUrls?: string[]
  }
} = {
  404: {
    includeUrls: ['/order', '/customer', '/partner'],
    redirectFunc: () => defaultRedirectOnApiError('404'),
    excludedUrls: ['/order-tracking']
  },
  403: {
    excludedUrls: ['/recovery', '/registration', '/order-guest/confirm', '/order-yarche-guest/confirm'],
    redirectFunc: () => defaultRedirectOnApiError('403')
  },
  PARSING_ERROR: {
    redirectFunc: () => defaultRedirectOnApiError('404')
  },
  ...Object.fromEntries(serverErrorCodes.map((code500) => [code500, { redirectFunc: redirectOnServerError }]))
}

export function checkRedirect(status: FetchBaseQueryError['status'], url?: string) {
  const redirectInfo = REDIRECT_BY_ERROR[status]
  if (!redirectInfo) {
    return
  }

  const redirectIncludedUrls = redirectInfo.includeUrls
  const redirectExcludedUrls = redirectInfo.excludedUrls || []
  const redirectByErrorFunc = redirectInfo.redirectFunc

  if (redirectExcludedUrls.length && url) {
    const isUrlExcluded = redirectExcludedUrls.some((rUrl) => url.includes(rUrl))

    if (isUrlExcluded) {
      return
    }
  }

  if (redirectIncludedUrls && url) {
    const isUrlMatches = redirectIncludedUrls.some((rUrl) => url.includes(rUrl))

    if (!isUrlMatches || !redirectByErrorFunc) {
      return
    }

    redirectByErrorFunc()

    return true
  }

  if (!redirectByErrorFunc) {
    return
  }

  redirectByErrorFunc()

  return true
}
